export default __webpack_public_path__ + "static/media/G0860.Breech_01_footling.1695376380000.93914374.jpg";